import React, { useEffect, useState } from 'react';
import style from "./css/nav.module.css";
import logo from './media/logo.png';
import Notification from './Notification';
import { NotificationInterface } from './Vars';
interface NavBarProps {

}

const NavBar: React.FC<NavBarProps> = () => {

    const [navVisibility, setNavVisibility] = useState<boolean>(false);
    useEffect(() => {
        console.log(window.innerWidth);
        if (window.innerWidth > 900) {
            setNavVisibility(true)
        }
    }, [window.visualViewport?.width])
    const nt:NotificationInterface = {
        id:1,
        text:"This is a notification ",
        type:"success"
    }
    return (
        <>
            {<Notification messages={[]}/>}
            <nav className={style.nav}>
                <img src={logo} alt="" className={style.logo} />





                {
                    navVisibility ?
                        (
                            <>

                                <ul className={style.navList}>

                                    {
                                        window.innerWidth < 900 ? (
                                            <>
                                                <li >
                                                    <div onClick={(e) => { e.preventDefault(); setNavVisibility(!navVisibility); }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                                            <path d="M8 23.75L6.25 22L13.25 15L6.25 8L8 6.25L15 13.25L22 6.25L23.75 8L16.75 15L23.75 22L22 23.75L15 16.75L8 23.75Z" fill="#5F6368" />
                                                        </svg>
                                                    </div>

                                                </li>
                                            </>
                                        ) : (<></>)
                                    }

                                    <a href="/"><li id='Home' className={style.listItem}>Home</li></a>
                                    <a href="/about/"><li id='AboutUs' className={style.listItem}>About Us</li></a>
                                    <a href="/support/"><li className={style.listItem}>Contact Us</li></a>
                                    <a href="/dashboard/"><li className={style.listItem}>dashboard</li></a>
                                    <a href="/login/"><li className={style.listItem}>Login</li></a>
                                </ul>
                            </>
                        )
                        : (
                            <></>
                        )
                }

                {
                    window.innerWidth < 900 ? (
                        <>
                            <div className={style.menuButton} onClick={(e) => { e.preventDefault(); setNavVisibility(!navVisibility); }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                                    <path d="M1 14.5714H20M1 7.78571H20M1 1H20" stroke="#B0B0B0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </>
                    ) : (<></>)
                }


            </nav>
            <div className={style.pseudoNav}>

            </div>
        </>
    );
};

export default NavBar;